export default {
  search: {
    title: 'Solicitudes de Información',
    filters: {
      filter1: {
        placeholder: 'Buscar por ID Solicitud, Descripción de Solicitud, Descripción del Item Solicitado',
        button: 'Buscar',
      },
      filter3: {
        label1: 'ID Solicitud',
        label2: 'Nombre',
        label3: 'Fecha Creación',
        label4: 'Fecha de Cierre',
        column5: {
          label1: 'Resumen',
          content1: 'Invitados',
          content2: 'Revisadas',
          content3: 'Respondidas',
        },
        column6: {
          label1: 'Estado',
          label2: 'Publicada',
          label3: 'Cerrada',
        },
        link1: 'Ver Solicitud',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/buyer/request_information/search.js